/* eslint-disable no-console */
import axios from 'axios';
import { ClientLogger } from '../monitoring/clientLogger';

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Client-Device': 'browser',
  'Accept-Language': 'pt-BR',
};

const callApiBase = (call) => {
  const urlApi = process.env.WISEUPCORP_API_BASE_URL;
  const urlMock = process.env.MOCK_API_BASE_URL;

  let {
    endpoint,
    headers,
    method = 'GET',
    token = '',
    params = {},
    data = {},
    mock = false,
    showJSON = false,
    showConsoleLog = false,
    title = '',
    responseType = 'json',
  } = call;

  // Config Headers
  headers = { ...headers, ...defaultHeaders };
  // Auth BEARER
  if (token) headers.Authorization = `Bearer ${token}`;
  // Helpers for Debug
  if (showJSON)
    console.log(`[${title} - CALL API JSON DATA]`, JSON.stringify(data));
  if (showConsoleLog) {
    console.log(`[${title} - CALL API COMPLETE]`, {
      headers,
      method,
      endpoint,
      params,
      data,
    });
  }

  const apiBase = axios.create({
    baseURL: mock ? urlMock : urlApi,
  });

  apiBase.interceptors.response.use(
    (response) => {
      if (showConsoleLog) console.log(`${title} - RESPONSE`, response);
      return response;
    },
    async (error) => {
      if (showConsoleLog) console.error(`${title} - ERROR`, error);
      ClientLogger.captureHTTPException(error);
      return Promise.reject(error);
    }
  );

  if (method === 'GET' || method === 'DELETE') {
    return apiBase(endpoint, {
      params: { ...params },
      headers,
      method,
      responseType,
    });
  }

  return apiBase(endpoint, {
    headers,
    method,
    data,
    responseType,
  });
};

export default callApiBase;
export { callApiBase };
